import { Module, ModuleRefImpl, type OnApplicationBootstrap } from 'framework/core';

import { PlatformLoader } from '../platform/platform.loader';
import { PlatformModule } from '../platform/platform.module';
import { RecentlyViewedProductService } from './recently-viewed-product.service';

@Module({
  imports: [PlatformModule],
  providers: [RecentlyViewedProductService],
})
export class RecentlyViewedProductModule implements OnApplicationBootstrap {
  constructor(private moduleRef: ModuleRefImpl) {}

  onApplicationBootstrap(): void | Promise<void> {
    const recentlyViewedProductService = this.moduleRef.get<RecentlyViewedProductService>(
      RecentlyViewedProductService
    );

    const { router, product } = this.moduleRef.get<PlatformLoader>(PlatformLoader).platform;

    if (router.page === 'product' && product?.id) {
      recentlyViewedProductService.addRecentlyViewedProduct(product.id);
    }
  }
}
